export default "__VITE_ASSET__b3264cbb__"